module.exports = __webpack_public_path__ + "img/google.645a8e18.svg";